//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getStyle } from '@/utils/style'
import runAnimation from '@/utils/runAnimation'
import { mixins } from '@/utils/events'
import {publishMqtt} from '@/utils/mqtt'
import {modelData} from '@/utils/mqtt'
import { mapState } from 'vuex'

export default {
    mixins: [mixins],
    props: {
        config: {
            type: Object,
            require: true,
            default: () => {},
        },
    },
    data() {
        return {
            modelData,
        }
    },
    mounted() {
        // runAnimation(this.$refs.component.$el, this.config.animations)
    },
    computed: {
        ...mapState([
            'editMode',
        ]),
    },
    methods: {
        getStyle,

        handleClick() {
            if(this.editMode == 'show') {
                if(this.config.events.publish) {
                    if(this.config.events.publishComponents.length == 0) {
                        publishMqtt(this.config.events.publishTopic, this.config.events.publishPayload)
                    } else {
                        let payload = ''
                        this.config.events.publishComponents.forEach(item => {
                            payload = payload + this.modelData[item] + ';'
                        })
                        payload = payload.substring(0, payload.length - 1)
                        publishMqtt(this.config.events.publishTopic, payload)
                    }
                }
            }  
        },
    },
}
